import React from "react";
import userimg from "assets/images/avatar.svg";
import msgimg from "assets/images/msg.svg";
import { Link } from "react-router-dom";
import { getFormattedDate } from "utils";
import useCurrentUser from "hooks/useCurrentUser";

const JobCard = ({
    item,
    handleShow
}) => {
    const { user } = useCurrentUser();
    return (
        <div className="tab-content-bg">
        <div className="job-card">
            <div className="d-flex align-items-center gap-2">
                <img
                    alt="avatar"
                    src={`${user?.baseS3Url}${item?.clientId?.avatar}`}
                    className="round-img"
                    onError={(e) => {
                        e.currentTarget.onerror = null; // prevent infinite loop if userimg also fails
                        e.currentTarget.src = userimg;
                    }}
                />
                <p className="mb-0 dark-textss">{item?.clientId?.fullName}</p>
            </div>
            <h3>{item?.title}</h3>
            <Link to={`/my-jobs/${item?._id}`}>
                <p className="light-texts">Destination</p>
                <address className="dark-textss destination">
                    {item?.address}
                </address>
                <div className="row">
                    <div className="col-lg-6">
                        <div>
                            <p className="light-texts">Required Date</p>
                            <p className="dark-textss">{getFormattedDate(item?.requiredDate)}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div>
                            <p className="light-texts">Area Size ({item?.areaUnit?.toLowerCase()})</p>
                            <p className="dark-textss">{item?.areaSize}</p>
                        </div>
                    </div>
                </div>
            </Link>
            <div className="d-flex flex-wrap gap-2 justify-content-between mt-1">
                <Link to={`/my-jobs/${item?._id}`} className="btn white-btn">
                    Review Job
                </Link>
                <button onClick={() => handleShow(item?._id)} className="btn blue-btn">
                    Bid Now
                </button>
            </div>
            <div className="msg-v">
                <img alt="chat" src={msgimg} />
            </div>
        </div>
        </div>
    );
};

export default JobCard;
